'use strict';
import React, { Component } from 'react';
import MontoMask from '../../../../../Common/Components/Mask/MontoMask'

class ImporteCuotaColumn extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { Importe, Cierre } = this.props;

        return <td className={"bordeado th-cierres lbl-cierres-importe" + (Cierre == 6 ? " col-grey" : "")}>
            <MontoMask monto={Importe} moneda="" />&nbsp;&nbsp;
        </td>

    }

}
export default ImporteCuotaColumn;